export default "__VITE_ASSET__DR8rcK_9__"